module.exports = __webpack_public_path__ + "static/media/enccd_logo.60507c70.webp";